import { Component, ViewChild } from '@angular/core';
import { TableConfig } from 'app/shared/util/table-config.utils';
import { Log } from "ng2-logger";
import { Lift } from '@models/lift.model';
import { LiftCreateModalComponent } from './components/lift-create-modal/lift-create-modal.component';

@Component({
    selector: 'app-lifts-entry',
    templateUrl: 'lifts.component.html',
    styleUrls: ['lifts.component.scss']
})
export class LiftsComponent {
    _logger = Log.create(LiftsComponent.name);

    @ViewChild(LiftCreateModalComponent, {static: true}) liftCreateModal: LiftCreateModalComponent;

    config = new TableConfig();

    lifts: Array<Lift> = [];

}
